interface AssignmentDetailsProps {
  submissionDateAndTime?: string;
}

const AssignmentDetails = ({
  submissionDateAndTime,
}: AssignmentDetailsProps) => {
  const guidelines = [
    "Record your self-introduction video in vertical or portrait orientation.",
    "Ensure you are in a well-lit environment with clear audio.",
    "Position the camera at eye level to create a natural and engaging appearance.",
    "Avoid extreme angles that could distort your image.",
    "Frame your face and upper body comfortably within the shot.",
    "Choose a clean, neutral background that complements your presentation.",
    "Feel free to use a smartphone or recording device with good video quality.",
    "Once recorded, upload the video to the provided platform.",
  ];

  return (
    <section className="border border-[#E4E7EC] rounded-xl">
      {/* title */}
      <div className="flex justify-between py-3.5 px-5 bg-[#17457D0A] border-b border-[#E4E7EC] rounded-t-xl">
        <h4 className="text-[#1D2939] text-lg leading-6 tracking-[-1%] font-semibold">
          Assignment Details
        </h4>
        <p className="text-[#1D2939] leading-6 tracking-[-1%]">
          <span className="text-lg font-semibold">
            Submission time - 24 Hours
          </span>{" "}
          <span>({submissionDateAndTime})</span>
        </p>
      </div>

      {/* Description */}
      <Section title="Description">
        <SectionContent>
          Congratulations on being shortlisted for the Passionbits Anchor Talent
          position! We're excited to learn more about you through a brief
          self-introduction video. This video will allow us to evaluate your
          communication skills, confidence, and dedication to excellence.
          Additionally, it holds the potential to be featured on our website,
          introducing you to our clients and showcasing your potential
          contribution to the Passionbits team.
        </SectionContent>
      </Section>

      {/* Script */}
      <Section title="Script">
        <div className="bg-[#F0F5F9] text-[#667085]  border border-[#F1F1F1] p-3 rounded-[10px]">
         <p>
         "Hello, I'm one of Passionbits' anchor talents. Excited to collaborate
         on upcoming projects and create something amazing together!"
         </p>
          <br />
         <p>
         Additionally, some scripts might involve basic display of emotions
          hence -please showcase 3-4 different expressions/emotions based on
          these scenarios:
         </p>
          <ul className="list-disc pl-4 py-2">
            <li>
              Excitement – You just got an email saying you've landed your dream
              project.
            </li>
            <li>
              Curiosity – You overhear two colleagues whispering about a secret
              strategy that could change the industry.
            </li>
            <li>
              Concern – A close friend tells you they might lose their job due
              to unexpected layoffs.
            </li>
            <li>
              Anger – A client who promised to sign a deal suddenly backs out
              without an explanation.
            </li>
          </ul>
         <p>
         Looking forward to seeing your range!
         </p>
          {/* <p className="text-[#667085] text-sm leading-5 tracking-[-0.75%]">
            Hello, I'm (your first name), Passionbits' anchor talent. I'm
            excited to work with you on upcoming projects. Let's create
            something amazing together.
          </p> */}
        </div>
      </Section>

      {/* Introduction */}
      <Section title="Introduction">
        <ul className="space-y-2">
          {guidelines.map((guideline, index) => (
            <li
              key={index}
              className="text-[#667085] text-sm leading-[22px] tracking-[-0.1]"
            >
              {index + 1}. {guideline}
            </li>
          ))}
        </ul>
      </Section>

      {/* Attire */}
      <Section title="Attire">
        <SectionContent>
          Select professional attire that resonates with the image of a leading
          anchor talent. Choose colours and styles that enhance your on-camera
          presence while avoiding distracting patterns or overly casual clothing
        </SectionContent>
      </Section>

      {/* Note */}
      <Section title="Note">
        <SectionContent>
          Upon submitting your videos, please acknowledge that this & your
          earlier shared samples may be used for promotional purposes on our
          website and other platforms, with appropriate attribution to you as
          the content creator
        </SectionContent>
      </Section>
    </section>
  );
};

const SectionHeader = ({ children }: { children: React.ReactNode }) => (
  <h6 className="text-sm leading-5 tracking-[-1%] font-medium">{children}</h6>
);

const SectionContent = ({ children }: { children: React.ReactNode }) => (
  <p className="text-[#667085] text-sm leading-[22px] tracking-[-1%]">
    {children}
  </p>
);

const Section = ({
  title,
  children,
  className = "",
}: {
  title: string;
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={`space-y-2.5 py-5 border-b border-[#E4E7EC] px-5 ${className}`}
  >
    <SectionHeader>{title}</SectionHeader>
    {children}
  </div>
);

export default AssignmentDetails;
